
  import { defineComponent, onMounted, ref, watch } from "vue";
  import $ from "jquery";
  export default defineComponent({
    name: "ProCateList",
    props: {
      list: {
        type: Array,
        default: () => {
          return [];
        },
      },
      children: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    emits: ["handleclick", "handlesecclick"],
    setup(props, ctx) {
      const height = ref("0px");
      onMounted(() => {
        height.value =
                Number($(window).height()) -
                Number($("header").height()) -
                Number($(".home-wapper .title").height()) -
                Number($("footer").height()) +
                "px";
      });
      const active = ref(0);
      watch(
              () => {
                return props.list;
              },
              (list) => {
                active.value = (list as any)[0].categoryCode;
              }
      );

      function onClick(anclassid: string,nclassid: string) {
        active.value = Number(anclassid);
        ctx.emit("handleclick", anclassid,nclassid);
      }
      function onSecond(anclassid: string,nclassid: string,columnType: string) {
        if (!anclassid) {
          anclassid = String(active.value);
        }
        ctx.emit("handlesecclick",  anclassid,nclassid,columnType);
      }

      return {
        height,
        onClick,
        onSecond,
        active,
      };
    },
  });
